export default __webpack_public_path__ + "static/media/hotjar.5fd66248.png";